import { ReactNode } from "react";

import { cn } from "@/lib/utils";

type DetailProps = {
  label: string;
  value: ReactNode;
  className?: string;
};

function isEmptyValue(value: ReactNode) {
  return value === null || value === undefined || value === "";
}

export function Detail({ label, value, className }: DetailProps) {
  return (
    <div
      className={cn(
        "grid grid-cols-[minmax(0,1fr)_minmax(0,auto)] items-start gap-x-3 gap-y-1 text-sm",
        className
      )}
    >
      <span className="min-w-0 text-muted-foreground">{label}</span>

      <div className="min-w-0 text-right font-medium">{isEmptyValue(value) ? "-" : value}</div>
    </div>
  );
}
